module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment02_sp-0eed66538608b3c6f867a961efda3ece.png";